import { CardData } from "../../data/cardData";
import { CardsPlasticTypes } from "../../data/enums/cardsPlasticTypes";
import { CardsStates } from "../../data/enums/cardsStates";
import urlFilter from "../../filters/url.filter";
import { StatementModel } from "../statement/statementModel";

/**  Модель договора-счета. */
export class CardModel {
  public Data: CardData;

  public StatementModel: StatementModel;

  /** Тип пластиковой карты. */
  get CardPlasticType(): CardsPlasticTypes {
    let type = CardsPlasticTypes.Unknow;
    if (this.Data.Number.trim() !== "") {
      // Первая цифра номера карты - код типа пластиковых карт.
      const cn = this.Data.Number.substring(0, 1);
      if (cn == "5") type = CardsPlasticTypes.MasterCard;
      else if (cn == "4") type = CardsPlasticTypes.Visa;
      else if (cn == "2") type = CardsPlasticTypes.Mir;
      else if (cn == "6") type = CardsPlasticTypes.CUP;
    } else if (this.Data.PlasticType.trim() !== "") {
      // Если не определили по номеру, тогда пытаемся по описанию типа карты.
      const temp = this.Data.PlasticType.toLowerCase();
      // определяем по алиасу
      if (temp.includes("visa")) type = CardsPlasticTypes.Visa;
      if (temp.includes("mastercard")) type = CardsPlasticTypes.MasterCard;
      if (temp.includes("china") || temp.includes('cup')) type = CardsPlasticTypes.CUP;
      if (temp.includes("mir") || temp.includes("мир"))
        type = CardsPlasticTypes.Mir;
    }
    return type;
  }

  /** Заголовок типа пластиковой карты. */
  get CardPlasticTypeTitle(): string {
    let titleCard;
    switch (this.CardPlasticType) {
      case CardsPlasticTypes.MasterCard:
        titleCard = "MC";
        break;
      case CardsPlasticTypes.Visa:
        titleCard = "VISA";
        break;
      case CardsPlasticTypes.Mir:
        titleCard = "МИР";
        break;
      case CardsPlasticTypes.CHINA:
        titleCard = "China";
        break;
      default:
        titleCard = "CUP";
        break;
    }
    return titleCard;
  }

  /**Последние 4 цифры номера карты в формате ***0000 */
  get ShortCardNumber(): string {
    return "***" + this.Data.Number.substring(this.Data.Number.length - 4);
  }

  /**Ссылка на иконку карты */
  get CardImageUrl(): string {
    let imgUrl = "";
    if (this.Data.CodeCardImage.trim() !== "") {
      imgUrl = urlFilter(`Content/img/cards/${this.Data.CodeCardImage}`);
    }
    return imgUrl;
  }

  /**Признак активности карты */
  get IsActive(): boolean {
    return this.Data.CardState == CardsStates.Active;
  }
  /**Признак заблокированной карты */
  get IsBlocked(): boolean {
    return this.Data.CardState == CardsStates.Blocked;
  }
  /**Признак выпускающейся карты */
  get IsIssued(): boolean {
    return this.Data.CardState == CardsStates.Issued;
  }
  constructor(cardData: CardData | null = null) {
    this.Data = cardData ?? new CardData();
  }
}
